import { render, staticRenderFns } from "./MenuItemSeparator.vue?vue&type=template&id=f27f85ca&scoped=true"
import script from "./MenuItemSeparator.vue?vue&type=script&lang=js"
export * from "./MenuItemSeparator.vue?vue&type=script&lang=js"
import style0 from "./MenuItemSeparator.vue?vue&type=style&index=0&id=f27f85ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27f85ca",
  null
  
)

export default component.exports